import { connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import { IconNoiseSuppressionOff, IconNoiseSuppressionOn } from '../../base/icons/svg';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
import { isNoiseSuppressionEnabled, setNoiseSuppressionEnabledSetting } from '../functions';
import { jitsiLocalStorage } from '@jitsi/js-utils';
/**
 * Component that renders a toolbar button for toggling noise suppression.
 */
class NoiseSuppressionButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.ToggleNoiseSuppression';
        this.icon = IconNoiseSuppressionOn;
        this.label = 'toolbar.enableNoiseSuppression';
        this.tooltip = 'toolbar.enableNoiseSuppression';
        this.toggledIcon = IconNoiseSuppressionOff;
        this.toggledLabel = 'toolbar.disableNoiseSuppression';
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch, _isNoiseSuppressionEnabled } = this.props;
        jitsiLocalStorage.setItem('react/features/noise-suppression/enabled', (!_isNoiseSuppressionEnabled).toString());
        dispatch(setNoiseSuppressionEnabledSetting({
            target: {
                checked: !_isNoiseSuppressionEnabled,
            }
        }));
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isNoiseSuppressionEnabled;
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    return {
        _isNoiseSuppressionEnabled: isNoiseSuppressionEnabled(state)
    };
}
export default translate(connect(_mapStateToProps)(NoiseSuppressionButton));
